"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

require("../../assets/css/components/table/TableQtElements.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableQtElements = function (_React$Component) {
    _inherits(TableQtElements, _React$Component);

    function TableQtElements() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TableQtElements);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableQtElements.__proto__ || Object.getPrototypeOf(TableQtElements)).call.apply(_ref, [this].concat(args))), _this), _this.getRowsOptions = function () {
            return [{ key: '10', value: '10', text: '10' }, { key: '15', value: '15', text: '15' }, { key: '20', value: '20', text: '20' }];
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TableQtElements, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "flat-table-dropdown" },
                _react2.default.createElement(
                    "label",
                    { className: "flat-rows-label", formTarget: "numero-elementos", alt: "Selecione a quantidade de itens por p\xE1gina na tabela" },
                    "Qtd. Elementos :"
                ),
                _react2.default.createElement(_semanticUiReact.Dropdown, { className: "flat-table-select", id: "numero-elementos", placeholder: this.props.placeholder.toString(),
                    options: this.getRowsOptions(), onChange: this.props.onChange, selection: true })
            );
        }
    }]);

    return TableQtElements;
}(_react2.default.Component);

exports.default = TableQtElements;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/table/TableQtElements.js
// module id = 600
// module chunks = 0